<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" >Maintain Load Info</md-dialog-title>

     

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">

            <div>


        <div class = "layout">
          <md-field   :class="getValidationClass('dataForm.containerNo')">
            <label size="lg" class = "textlabel" for="containerNo">CONTAINER #</label>
            <md-input name="containerNo"
                      id="containerNo"
                      autocomplete="new-password"
                      v-model="dataForm.containerNo"
                      ref = "top"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.containerNo.required">containerNo is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.containerNo.minLength">Invalid containerNo<br/></div>
            </div>
          </md-field>
        </div>


        <div class = "layout">
            <md-field >
            <label for="Stage Status">Chassis No</label>
            <md-input name="chassisNo"
                      id="chassisNo"
                      autocomplete="new-password"
                      v-model="dataForm.chassisNo"
            />
            <div>
              <div class="md-error" v-if="!$v.dataForm.chassisNo.required">chassisNo is required<br/></div>
              <div class="md-error" v-else-if="!$v.dataForm.chassisNo.minLength">Invalid chassisNo<br/></div>
            </div>
          </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.carrier')">
                    <label size="lg" class = "textlabel" for="carrier">Carrier</label>
                    <md-input name="carrier"
                        id="carrier"
                        autocomplete="new-password"
                        v-model="dataForm.carrier"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.chassisDays')">
                    <label size="lg" class = "textlabel" for="freightType">Chassis Days</label>
                    <md-input name="chassisDays"
                        id="chassisDays"
                        autocomplete="new-password"
                        v-model="dataForm.chassisDays"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.chzDaysPaidOut')">
                    <label size="lg" class = "textlabel" for="carrier">Chassis Days Payout</label>
                    <md-input name="chzDaysPaidOut"
                        id="chzDaysPaidOut"
                        autocomplete="new-password"
                        v-model="dataForm.chzDaysPaidOut"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.chzDaysChargeBack')">
                    <label size="lg" class = "textlabel" for="carrier">Chassis Days ChargeBack</label>
                    <md-input name="chzDaysChargeBack"
                        id="chzDaysChargeBack"
                        autocomplete="new-password"
                        v-model="dataForm.chzDaysChargeBack"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.chzStartDate')">
                    <label size="lg" class = "textlabel" for="checkIn">CHZ Start Date</label>
                    <md-input name="chzStartDate"
                        id="chzStartDate"
                        autocomplete="new-password"
                        v-model="dataForm.chassisStartLocal"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.chzEndDate')">
                    <label size="lg" class = "textlabel" for="chzEndDate">CHZ End Date</label>
                    <md-input name="chzEndDate"
                        id="chzEndDate"
                        autocomplete="new-password"
                        v-model="dataForm.chassisEndLocal"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.loadRemark')">
                    <label size="lg" class = "textlabel" for="freightType">Load Comment</label>
                    <md-input name="loadRemark"
                        id="loadRemark"
                        autocomplete="new-password"
                        v-model="dataForm.loadRemark"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>



        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.totalHours')">
                    <label size="lg" class = "textlabel" for="freightType">Total Waiting hours</label>
                    <md-input name="totalHours"
                        id="totalHours"
                        autocomplete="new-password"
                        v-model="dataForm.totalHours"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.waitingTimePaidOut')">
                    <label size="lg" class = "textlabel" for="waitingTimePaidOut">Driver Waiting Time Payout</label>
                    <md-input name="waitingTimePaidOut"
                        id="waitingTimePaidOut"
                        autocomplete="new-password"
                        v-model="dataForm.waitingTimePaidOut"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.waitingTimeChargeBack')">
                    <label size="lg" class = "textlabel" for="waitingTimePaidOut">Driver Waiting Time ChargeBack</label>
                    <md-input name="waitingTimeChargeBack"
                        id="waitingTimeChargeBack"
                        autocomplete="new-password"
                        v-model="dataForm.waitingTimeChargeBack"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.deliveryEndLocal')">
                    <label size="lg" class = "textlabel" for="deliveryEndLocal">Delivery Start Date</label>
                    <md-input name="deliveryEndLocal"
                        id="taskStart"
                        autocomplete="new-password"
                        v-model="dataForm.deliveryEndLocal"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.deliveryEndTime')">
                    <label size="lg" class = "textlabel" for="deliveryEndTime">Delivery Start Time</label>
                    <md-input name="taskStart"
                        id="deliveryEndTime"
                        autocomplete="new-password"
                        v-model="dataForm.deliveryEndTime"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layout">
                    <md-field   :class="getValidationClass('dataForm.additionalCostToCustomer')">
                    <label size="lg" class = "textlabel" for="additionalCostToCustomer">Additonal Cost for Customer</label>
                    <md-input name="additionalCostToCustomer"
                        id="additionalCostToCustomer"
                        autocomplete="new-password"
                        v-model="dataForm.additionalCostToCustomer"
                        ref = "top"
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.prepull')">
                    <label size="lg" class = "textlabel" for="prepull">PREPULL</label>
                    <md-input name="prepull"
                        id="prepull"
                        autocomplete="new-password"
                        v-model="dataForm.prepull"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.dropoff')">
                    <label size="lg" class = "textlabel" for="dropoff">Drop Off</label>
                    <md-input name="dropoff"
                        id="dropoff"
                        autocomplete="new-password"
                        v-model="dataForm.dropoff"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.pierpass')">
                    <label size="lg" class = "textlabel" for="pierpass">PIER PASS</label>
                    <md-input name="pierpass"
                        id="pierpass"
                        autocomplete="new-password"
                        v-model="dataForm.pierpass"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>


        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.bobtail')">
                    <label size="lg" class = "textlabel" for="bobtail">Bobtail</label>
                    <md-input name="bobtail"
                        id="bobtail"
                        autocomplete="new-password"
                        v-model="dataForm.bobtail"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>

        <div class = "layoutHalf">
                    <md-field   :class="getValidationClass('dataForm.dryrun')">
                    <label size="lg" class = "textlabel" for="dryrun">Dry Run</label>
                    <md-input name="dryrun"
                        id="dryrun"
                        autocomplete="new-password"
                        v-model="dataForm. dryrun"
                        ref = "top"
                        disabled
                    />
                    <div>
                </div>
                </md-field>
        </div>

            </div>

            <div class = "alwaysShow">
                <div >
                    <callingApiCenter class = "custButtonRight" type="bar" :paths="['/api/w/gstConfirm/WebUpdateConfirmLoads','/api/w/users']"></callingApiCenter>
                    <md-dialog-actions >
                    <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
                    <md-button type="submit" class="md-raised custButton "><span class="icons-center material-icons">create</span>Save</md-button>
                    </md-dialog-actions>
                </div>
            </div>

        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    
  }
  

  .alwaysShow {
  position: fixed;
  
  right: 60px;
  top : 30px;
}


    .redButton{

        background-color: #c50000;
        z-index: 4;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }


.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}



  .custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}



    .heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;


}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
    
      font-family: Roboto Slab;
      margin: auto;
  }

  .layoutHalf{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 27px;
  }


  .md-table-row
{
  background: white;
}


.md-table.md-theme-default .md-table-row.md-selected-single
{
background: #726a95;
}



</style>
<script>
  import { validationMixin } from 'vuelidate';
  import dateFormat from '../utils/dateFormat';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    salesOffice: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    chassisDays:null,
    chzDaysPaidOut: null,
    chzDaysChargeBack: null,
    chzStartDate:null,
    chzEndDate:null,
    totalHours: null,
    waitingTimePaidOut: null,
    waitingTimeChargeBack: null,
    deliveryEndDate: null,
    additionalCostToCustomer: null,
    prepull: null,
    dropoff: null,
    pierpass: null,
    bobtail: null,
    dryrun: null,
    action: null,
    loadKey:null,
    chassisStartLocal: null,
    chassisEndLocal: null,
    deliveryEndLocal:null,
    deliveryEndTime:null,
    loadRemark:null,








    
  });

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      items: [],
      selected:null,
      drivers: [],
      loadList: [],
      dispatchers: [],
      ccicQcUsers: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
        salesOffice: {
          required,
          minLength: minLength(3),
        },
        containerNo:{},
        chassisNo:{},
        carrier:{},
        chassisDays:{},
        chzDaysPaidOut:{},
        chzDaysChargeBack:{},
        chzStartDate:{},
        chzEndDate:{},
        waitingTimePaidOut: {},
        waitingTimeChargeBack:{},
        totalHours:{},
        deliveryEndDate:{},
        additionalCostToCustomer: {},
        prepull: {},
        dropoff: {},
        pierpass: {},
        bobtail: {},
        dryrun: {},
        loadRemark: {},
      },
    },

 
    methods: {


    

      async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        this.dataForm.username = this.getUserProfile.username;

        if (existingUser) {
            this.dataForm.salesOffice = existingUser.salesOffice;
            this.dataForm.containerNo = existingUser.containerNo;
            this.dataForm.chassisNo = existingUser.chassisNo;
            this.dataForm.carrier = existingUser.carrier; 
            this.dataForm.chassisDays = existingUser.chassisDays;
            this.dataForm.chzDaysPaidOut = existingUser.chzDaysPaidOut;
            this.dataForm.chzDaysChargeBack = existingUser.chzDaysChargeBack;
            this.dataForm.chzStartDate = existingUser.chzStartDate;
            this.dataForm.chzEndDate = existingUser.chzEndDate;
            this.dataForm.totalHours = existingUser.totalHours;
            this.dataForm.waitingTimePaidOut = existingUser.waitingTimePaidOut;
            this.dataForm.waitingTimeChargeBack = existingUser.waitingTimeChargeBack;
            this.dataForm.deliveryEndDate = existingUser.deliveryEndDate;
            this.dataForm.additionalCostToCustomer = existingUser.additionalCostToCustomer;
            this.dataForm.prepull = existingUser.prepull;
            this.dataForm.dropoff = existingUser.dropoff;
            this.dataForm.pierpass = existingUser.pierpass;
            this.dataForm.bobtail = existingUser.bobtail;
            this.dataForm.dryrun = existingUser.dryrun;
            this.dataForm.loadKey = existingUser.loadKey;
            this.dataForm.loadRemark = existingUser.loadRemark;

            this.dataForm.chassisStartLocal = dateFormat.gstDateFormat(existingUser.chzStartDate);
            this.dataForm.chassisEndLocal = dateFormat.gstDateFormat(existingUser.chzEndDate);
            this.dataForm.deliveryEndLocal = dateFormat.gstDateFormat(existingUser.deliveryEndDate);
            this.dataForm.deliveryEndTime = dateFormat.time(existingUser.deliveryEndDate);

        }

        this.showDialog = true;
      },

      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },



     cancalAction(){
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },


     convertTime(){
        // console.log(existingUser.checkIn);
        // console.log(moment(existingUser.checkIn).format());
        // console.log(moment.tz(existingUser.checkIn, "America/New_York").format());
        // console.log(moment.tz(existingUser.checkIn, "America/Los_Angeles").format());
        // var ny = moment.tz(existingUser.checkIn, "America/New_York");
        // console.log(ny.format());
        // console.log(ny.toISOString());
     },

    async doSaveUser() {
       
        this.$v.dataForm.$touch();
        console.log(JSON.stringify(this.dataForm));
        const req = this.dataForm;
        req.action = 'CHANGE';
        console.log(req);
        //await  api.post("/api/w/gstConfirm/WebUpdateConfirmLoads", req)
        await  newAPIPost("/api/w/gstConfirm/WebUpdateConfirmLoads", req)
        .then(() => {
        this.$store.commit('clearApiError');
        this.showDialog = false;
        $('.btn-search-special-form-loads')
        .click(); });
         this.$store.commit('clearApiError');
      },
    },
  };
</script>
